import { useState, useRef, useEffect } from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import { Toaster } from 'sonner';

type LayoutContextType = {
    isSidebarOpen: boolean;
    toggleSidebar: () => void;
    sidebarRef: React.RefObject<HTMLDivElement | null>;
};


const Layout = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const sidebarRef = useRef<HTMLDivElement>(null);
    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (sidebarRef.current && !sidebarRef.current.contains(event.target as Node)) {
                setIsSidebarOpen(false);
            }
        };

        if (isSidebarOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isSidebarOpen]);


    return (
        <div className="relative flex min-h-screen w-screen flex-col bg-background-page text-primary font-jakarta">
            <Navbar />
            <div className="flex-1">
                <Outlet context={{ isSidebarOpen, toggleSidebar, sidebarRef } satisfies LayoutContextType} />
            </div>
            <Toaster
                theme="dark"
                position="bottom-right"
                richColors
                visibleToasts={5}
                toastOptions={{
                    className: 'text-sm font-jakarta',
                    
                }}
            />
            <Footer />
        </div>
    );
};

export function useLayout() {
    return useOutletContext<LayoutContextType>();
}

export default Layout;